import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Button, Image } from 'react-bootstrap';
import { translate } from 'react-i18next';

import i18n from '../../i18n';
import { changeLanguage } from '../../actions/app';

import fiFlagImage from '../../images/fi.svg';
import enFlagImage from '../../images/gb.svg';
import svFlagImage from '../../images/se.svg';
import ruFlagImage from '../../images/ru.svg';

class LanguageSelector extends Component {

  constructor(props) {
    super(props);
    this.onLanguageSelect = this.onLanguageSelect.bind(this);
    this.getName = this.getName.bind(this);
    this.getFlag = this.getFlag.bind(this);
    this.state = {
      activeLanguage: i18n.language,
      isChangingLanguage: false
    };
  }

  onLanguageSelect(language) {
    if (this.state.isChangingLanguage) return;
    
    this.setState({ isChangingLanguage: true });
    
    changeLanguage(language)
      .then(() => {
        this.setState({ activeLanguage: language, isChangingLanguage: false });
      })
      .catch((error) => {
        console.error('Failed to change language:', error);
        this.setState({ isChangingLanguage: false });
      });
  }

  getName(code) {
    const map = {
      fi: 'Suomi',
      sv: 'Svenska',
      en: 'English',
      ru: 'Русский'
    };
    return map[code];
  }

  getFlag(code) {
    const map = {
      fi: fiFlagImage,
      sv: svFlagImage,
      en: enFlagImage,
      ru: ruFlagImage
    };
    return map[code];
  }

  render() {
    const { languages, t } = this.props;
    const { activeLanguage } = this.state;
    return (
      <div id={'language-selector-container'}>
        <ButtonGroup>
          {Object
            .keys(languages)
            .filter(key => activeLanguage !== languages[key])
            .map(key =>
              <Button bsStyle="default" key={key} onClick={() => this.onLanguageSelect(languages[key])}>
                <Image alt={t('ariaLabels.flagImage')} src={this.getFlag(languages[key])} className="flag-image" />{this.getName(languages[key])}
              </Button>)
          }
        </ButtonGroup>
      </div>
    );
  }
}

LanguageSelector.propTypes = {
  languages: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default translate(['common'])(LanguageSelector);



// WEBPACK FOOTER //
// ./src/components/LanguageSelector/index.jsx